import React, { MouseEvent } from 'react';

interface SearchButtonProps {
  selected: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  title: string;
}

export const SearchButton = ({ selected, onClick, title }: SearchButtonProps) => {
  const classes = selected ? 'c-header-main-menu-item active' : 'c-header-main-menu-item';
  return (
    <button onClick={onClick} className={classes}>
      <i className='svg-icon pr-8 icon-symbol-search'></i>
      {title}
    </button>
  );
};
